import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    CircularProgress,
    Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            minWidth: '400px',
            maxWidth: '600px',
        },
    },
    dialogTitle: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    icon: {
        fontSize: '2rem',
    },
    content: {
        padding: theme.spacing(3),
    },
    message: {
        marginBottom: theme.spacing(2),
    },
    retryButton: {
        margin: theme.spacing(2),
    },
    loadingBox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
}));

const MaintenanceModal = ({ open, maintenanceInfo, onRetry, isRetrying }) => {
    const classes = useStyles();

    const message = maintenanceInfo?.message || 'Aplikasi sedang dalam pemeliharaan';
    const estimatedTime = maintenanceInfo?.estimatedTime;
    const contact = maintenanceInfo?.contact;

    return (
        <Dialog
            open={open}
            className={classes.dialog}
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle className={classes.dialogTitle}>
                <WarningIcon className={classes.icon} />
                <Typography variant="h6">Maintenance Mode</Typography>
            </DialogTitle>

            <DialogContent className={classes.content}>
                <Typography variant="body1" className={classes.message}>
                    {message}
                </Typography>

                {estimatedTime && (
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        <strong>Estimasi waktu:</strong> {estimatedTime}
                    </Typography>
                )}

                {contact && (
                    <Typography variant="body2" color="textSecondary">
                        <strong>Kontak:</strong> {contact}
                    </Typography>
                )}

                {isRetrying && (
                    <Box className={classes.loadingBox}>
                        <CircularProgress size={20} />
                        <Typography variant="body2" color="textSecondary">
                            Memeriksa status...
                        </Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onRetry}
                    color="primary"
                    variant="contained"
                    disabled={isRetrying}
                    className={classes.retryButton}
                >
                    {isRetrying ? 'Memeriksa...' : 'Coba Lagi'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MaintenanceModal;
